import React, {Fragment} from "react";
import {
    Link
} from "react-router-dom";
import ModalMsg from "../../components/ModalMsg";
import MenuBarTop from "./components/MenuBarTop";
import MenuToggle from "./components/MenuToggle";
import MenuConfigura from "./components/MenuConfigura";
import MenuSoci from "./components/MenuSoci";
import MenuVeicoli from "./components/MenuVeicoli";
import MenuCertificati from "./components/MenuCertificati";
import MenuContabilita from "./components/MenuContabilita";
import MenuQuote from "./components/MenuQuote";
import MenuNote from "./components/MenuNote";
import MenuArchivio from "./components/MenuArchivio";

export default function MenuAppView({
                                        user,
                                        isRuoloAdmin,
                                        isRuoloSegreteria,
                                        numRichiedenti,
                                        numCertificati,
                                        handleLogout,
                                        showToggle,
                                        showMenuBarTop,
                                        isRuoloClub,
                                        isRuoloAgenzia,
                                        isRuoloSocio,
                                        isRuoloCommissario,
                                        isRuoloPresidente,
                                        infoPagamento,
                                        show,
                                        hideMessage,
                                        titoloMsg,
                                        modalMsg,
                                        showMessage,
                                        sfondoNero,
                                        showArchivio,
                                        documentiSocio,
                                    }) {

    return (
        <Fragment>
            <ModalMsg
                show={show}
                titolo={titoloMsg}
                handleClose={hideMessage}
                testo={modalMsg}/>
            <div className=" fixed-top">
                {
                    showMenuBarTop() &&
                    <MenuBarTop
                        user={user}
                        numRichiedenti={numRichiedenti}
                        numCertificati={numCertificati}
                        isRuoloSegreteria={isRuoloSegreteria}
                        handleLogout={handleLogout}
                        isRuoloAdmin={isRuoloAdmin}
                    />
                }
                <nav className={"navbar navbar-expand-md navbar-light " + (sfondoNero && 'ns-navbar-black')}>
                    <div className="container-fluid">
                        <img src={"logo.png"} className={"ns-logo-icon"}/>
                        {
                            showToggle() &&
                            <MenuToggle/>
                        }
                        <div className="collapse navbar-collapse" id="navbarCollapse">
                            {
                                user &&
                                <ul className="navbar-nav menu-centro">
                                    <li className="nav-item">
                                        <Link className="nav-link" aria-current="page" to="/home">
                                            <div data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                                                <i className="fas fa-home"/>
                                            </div>
                                        </Link>
                                    </li>
                                    <MenuConfigura
                                        isRuoloAdmin={isRuoloAdmin}
                                        isRuoloSegreteria={isRuoloSegreteria}
                                    />
                                    <MenuSoci
                                        isRuoloAdmin={isRuoloAdmin}
                                        isRuoloSegreteria={isRuoloSegreteria}
                                        isRuoloClub={isRuoloClub}
                                        isRuoloAgenzia={isRuoloAgenzia}
                                    />
                                    <MenuVeicoli
                                        isRuoloSocio={isRuoloSocio}
                                        user={user}
                                        showMessage={showMessage}
                                        isRuoloPresidente={isRuoloPresidente}
                                        isRuoloCommissario={isRuoloCommissario}
                                    />
                                    <MenuCertificati
                                        user={user}
                                        showMessage={showMessage}
                                        isRuoloSocio={isRuoloSocio}
                                        isRuoloAdmin={isRuoloAdmin}
                                        isRuoloSegreteria={isRuoloSegreteria}
                                    />
                                    <MenuContabilita
                                        isRuoloAdmin={isRuoloAdmin}
                                        isRuoloSegreteria={isRuoloSegreteria}
                                    />
                                    <MenuQuote
                                        user={user}
                                        showMessage={showMessage}
                                        isRuoloSocio={isRuoloSocio}
                                        infoPagamento={infoPagamento}
                                    />
                                    <MenuNote
                                        isRuoloClub={isRuoloClub}
                                        isRuoloSocio={isRuoloSocio}
                                        isRuoloAgenzia={isRuoloAgenzia}
                                    />
                                    <MenuArchivio
                                        showArchivio={showArchivio}
                                    />
                                    {
                                        documentiSocio && documentiSocio.length > 0 &&
                                        <li className="nav-item">
                                            <Link className="nav-link" aria-current="page"
                                                  to="/documenti-socio">
                                                <div data-bs-toggle="collapse"
                                                     data-bs-target=".navbar-collapse.show">
                                                    <i className="fas fa-file"/> Documenti
                                                </div>
                                            </Link>
                                        </li>
                                    }
                                </ul>
                            }
                        </div>
                    </div>
                </nav>
            </div>
        </Fragment>
    );
}